module.exports = __webpack_public_path__ + "img/tipology_mail_careers.1ada56da.png";